import { TemplateDetailsGeneralDto } from "@domain/project/template/property/project/details/general/template-details-general.dto";
import { TemplateGoodsRecipientDto } from "@domain/project/template/property/project/details/goods-recipient/template-goods-recipient.dto";
import { Type } from "class-transformer";
import { IsOptional } from "class-validator";
import { TemplateInformationDto } from "./information/template-information.dto";

export class TemplateDetailsDto {
  @IsOptional()
  @Type(() => TemplateDetailsGeneralDto)
  general?: TemplateDetailsGeneralDto;

  @IsOptional()
  @Type(() => TemplateInformationDto)
  information?: TemplateInformationDto;

  @IsOptional()
  @Type(() => TemplateGoodsRecipientDto)
  goodsRecipient?: TemplateGoodsRecipientDto;
}
